// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Play one captured conversation as the vendor device behind a bank.
 */
export class SimulationCaptureReplay implements flatbuffers.IUnpackableObject<SimulationCaptureReplayT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationCaptureReplay {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationCaptureReplay(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationCaptureReplay,
  ): SimulationCaptureReplay {
    return (obj || new SimulationCaptureReplay()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSimulationCaptureReplay(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationCaptureReplay,
  ): SimulationCaptureReplay {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationCaptureReplay()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  assetId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Which captured endpoint to play ("ip:port" of a flow's vendor side).
   * Independent of the bank's `vendor_address`, so one capture can drive a
   * bank whose channel uses another address.
   */
  flowVendorAddress(): string;
  flowVendorAddress(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  flowVendorAddress(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  /**
   * Multiplier on the captured inter-packet gaps; 1.0 is real time.
   */
  speed(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 1.0;
  }

  /**
   * Longest gap the replay waits, in milliseconds; 0 means the simulator's
   * default. Keep it under VTS's three-minute idle watchdog.
   */
  maxGapMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  /**
   * Start again from the beginning when the flow ends.
   */
  loop(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  /**
   * Pause between passes, in milliseconds.
   */
  loopDelayMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 1000;
  }

  /**
   * Response-rule preset the simulator answers VTS with (empty means the
   * protocol's default pack). Every replay reads and drains what VTS sends.
   */
  responseRules(): string | null;
  responseRules(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  responseRules(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Skip the captured login/authentication exchange and begin at the first
   * data frame (MCE).
   */
  startAtFirstData(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  static startSimulationCaptureReplay(builder: flatbuffers.Builder) {
    builder.startObject(8);
  }

  static addAssetId(builder: flatbuffers.Builder, assetIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, assetIdOffset, 0);
  }

  static addFlowVendorAddress(
    builder: flatbuffers.Builder,
    flowVendorAddressOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(1, flowVendorAddressOffset, 0);
  }

  static addSpeed(builder: flatbuffers.Builder, speed: number) {
    builder.addFieldFloat32(2, speed, 1.0);
  }

  static addMaxGapMs(builder: flatbuffers.Builder, maxGapMs: number) {
    builder.addFieldInt32(3, maxGapMs, 0);
  }

  static addLoop(builder: flatbuffers.Builder, loop: boolean) {
    builder.addFieldInt8(4, +loop, +true);
  }

  static addLoopDelayMs(builder: flatbuffers.Builder, loopDelayMs: number) {
    builder.addFieldInt32(5, loopDelayMs, 1000);
  }

  static addResponseRules(builder: flatbuffers.Builder, responseRulesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, responseRulesOffset, 0);
  }

  static addStartAtFirstData(builder: flatbuffers.Builder, startAtFirstData: boolean) {
    builder.addFieldInt8(7, +startAtFirstData, +true);
  }

  static endSimulationCaptureReplay(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // asset_id
    builder.requiredField(offset, 6); // flow_vendor_address
    return offset;
  }

  static createSimulationCaptureReplay(
    builder: flatbuffers.Builder,
    assetIdOffset: flatbuffers.Offset,
    flowVendorAddressOffset: flatbuffers.Offset,
    speed: number,
    maxGapMs: number,
    loop: boolean,
    loopDelayMs: number,
    responseRulesOffset: flatbuffers.Offset,
    startAtFirstData: boolean,
  ): flatbuffers.Offset {
    SimulationCaptureReplay.startSimulationCaptureReplay(builder);
    SimulationCaptureReplay.addAssetId(builder, assetIdOffset);
    SimulationCaptureReplay.addFlowVendorAddress(builder, flowVendorAddressOffset);
    SimulationCaptureReplay.addSpeed(builder, speed);
    SimulationCaptureReplay.addMaxGapMs(builder, maxGapMs);
    SimulationCaptureReplay.addLoop(builder, loop);
    SimulationCaptureReplay.addLoopDelayMs(builder, loopDelayMs);
    SimulationCaptureReplay.addResponseRules(builder, responseRulesOffset);
    SimulationCaptureReplay.addStartAtFirstData(builder, startAtFirstData);
    return SimulationCaptureReplay.endSimulationCaptureReplay(builder);
  }

  unpack(): SimulationCaptureReplayT {
    return new SimulationCaptureReplayT(
      this.assetId() !== null ? this.assetId()!.unpack() : null,
      this.flowVendorAddress(),
      this.speed(),
      this.maxGapMs(),
      this.loop(),
      this.loopDelayMs(),
      this.responseRules(),
      this.startAtFirstData(),
    );
  }

  unpackTo(_o: SimulationCaptureReplayT): void {
    _o.assetId = this.assetId() !== null ? this.assetId()!.unpack() : null;
    _o.flowVendorAddress = this.flowVendorAddress();
    _o.speed = this.speed();
    _o.maxGapMs = this.maxGapMs();
    _o.loop = this.loop();
    _o.loopDelayMs = this.loopDelayMs();
    _o.responseRules = this.responseRules();
    _o.startAtFirstData = this.startAtFirstData();
  }

  unpackFields(...fields: string[]): SimulationCaptureReplayT {
    const t = new SimulationCaptureReplayT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("asset_id")) {
      t.assetId = this.assetId() !== null ? this.assetId()!.unpack() : null;
    }
    if (fieldSet.has("flow_vendor_address")) {
      t.flowVendorAddress = this.flowVendorAddress();
    }
    if (fieldSet.has("speed")) {
      t.speed = this.speed();
    }
    if (fieldSet.has("max_gap_ms")) {
      t.maxGapMs = this.maxGapMs();
    }
    if (fieldSet.has("loop")) {
      t.loop = this.loop();
    }
    if (fieldSet.has("loop_delay_ms")) {
      t.loopDelayMs = this.loopDelayMs();
    }
    if (fieldSet.has("response_rules")) {
      t.responseRules = this.responseRules();
    }
    if (fieldSet.has("start_at_first_data")) {
      t.startAtFirstData = this.startAtFirstData();
    }
    return t;
  }
}

export class SimulationCaptureReplayT implements flatbuffers.IGeneratedObject {
  constructor(
    public assetId: UuidT | null = null,
    public flowVendorAddress: string | Uint8Array | null = null,
    public speed: number = 1.0,
    public maxGapMs: number = 0,
    public loop: boolean = true,
    public loopDelayMs: number = 1000,
    public responseRules: string | Uint8Array | null = null,
    public startAtFirstData: boolean = true,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.assetId === null || this.assetId === undefined) {
      throw new Error('Required field "asset_id" is not set');
    }
    if (this.flowVendorAddress === null || this.flowVendorAddress === undefined) {
      throw new Error('Required field "flow_vendor_address" is not set');
    }
    const assetId = this.assetId !== null ? this.assetId!.pack(builder) : 0;
    const flowVendorAddress =
      this.flowVendorAddress !== null ? builder.createString(this.flowVendorAddress!) : 0;
    const responseRules =
      this.responseRules !== null ? builder.createString(this.responseRules!) : 0;

    return SimulationCaptureReplay.createSimulationCaptureReplay(
      builder,
      assetId,
      flowVendorAddress,
      this.speed,
      this.maxGapMs,
      this.loop,
      this.loopDelayMs,
      responseRules,
      this.startAtFirstData,
    );
  }

  clone(): SimulationCaptureReplayT {
    const obj = new SimulationCaptureReplayT();
    obj.assetId = this.assetId !== null ? this.assetId!.clone() : null;
    obj.flowVendorAddress = this.flowVendorAddress;
    obj.speed = this.speed;
    obj.maxGapMs = this.maxGapMs;
    obj.loop = this.loop;
    obj.loopDelayMs = this.loopDelayMs;
    obj.responseRules = this.responseRules;
    obj.startAtFirstData = this.startAtFirstData;
    return obj;
  }

  equals(other: SimulationCaptureReplayT): boolean {
    if (this.assetId !== null && other.assetId !== null) {
      if (!this.assetId!.equals(other.assetId!)) return false;
    } else if (this.assetId !== other.assetId) return false;
    if (this.flowVendorAddress !== other.flowVendorAddress) return false;
    if (!Object.is(this.speed, other.speed)) return false;
    if (this.maxGapMs !== other.maxGapMs) return false;
    if (this.loop !== other.loop) return false;
    if (this.loopDelayMs !== other.loopDelayMs) return false;
    if (this.responseRules !== other.responseRules) return false;
    if (this.startAtFirstData !== other.startAtFirstData) return false;
    return true;
  }
}

export function verifySimulationCaptureReplay(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "asset_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "flow_vendor_address");
    verifier.checkScalarField(tablePos, 8, 4);
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 18, 1);
  } finally {
    verifier.popDepth();
  }
}
